import styled from '@emotion/styled';

const ButtonsWrapper = styled('div')(
  {
    position: 'sticky',
    bottom: 0,
    paddingTop: 27,
    paddingBottom: 27,
    display: 'flex',
    gap: 21,
    flexDirection: 'column',
    width: '100%',
    borderTopStyle: 'solid',
    borderTopWidth: 1
  },
  ({ theme }) => ({
    borderTopColor: theme.palette.colors.azureish,
    backgroundColor: theme.palette.colors.white
  })
);

export default ButtonsWrapper;
